import React from "react";
import {Link} from "react-router-dom";
import {css} from "@emotion/css";
import {Icon, Text, styled, theme} from "@reside/ui";
import {TableUserDto} from "../../../../utils/types/user";
import {PERMISSIONS_MANAGEMENT_LIST_PATH} from "../permissions-user-detail";
import {formatBulkUserNames} from "./bulkPermissions.helpers";

type Props = Readonly<{
  users: ReadonlyArray<TableUserDto>;
}>;

export const PermissionsBulkEditHeader = ({users}: Props) => (
  <HeaderSection>
    <BackLink to={PERMISSIONS_MANAGEMENT_LIST_PATH}>
      <Icon name="left" size={14} />
      Back to list
    </BackLink>
    <ProfileCard>
      <Text fontWeight="bold" className={styles.title}>
        Editing permissions for {users.length} user{users.length === 1 ? "" : "s"}
      </Text>
      <UserNames>{formatBulkUserNames(users)}</UserNames>
    </ProfileCard>
  </HeaderSection>
);

const styles = {
  title: css`
    font-size: 24px;
    line-height: 32px;
    margin: 0 0 8px;
  `,
};

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

const BackLink = styled(Link)`
  align-items: center;
  color: ${theme.color.primary};
  display: inline-flex;
  font-size: 16px;
  font-weight: 500;
  gap: 8px;
  text-decoration: none;
  width: fit-content;

  &:hover {
    color: ${theme.color.primary};
  }
`;

const ProfileCard = styled.div`
  background: #ffffff;
  border: 1px solid ${theme.color.primary};
  border-radius: 8px;
  padding: 24px 32px;
`;

const UserNames = styled(Text)`
  color: ${theme.color.gray150};
  display: block;
  font-size: 14px;
  line-height: 24px;
`;
